import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/taskTags/importer/taskTagsImporterActions'

export default importerReducers(actions)
